/* src/app/modules/shared/components/add-tag/add-tag.component.scss */
mat-card {
  margin: 10px 0;
}
/*# sourceMappingURL=add-tag.component.css.map */
